export const regionPrefixes = {
  0: "Uusimaa",
  1: "Uusimaa",
  2: "Uusimaa",
  3: "Uusimaa",
  4: "Uusimaa",
  5: "Uusimaa",
  6: "Uusimaa",
  7: "Uusimaa",
  8: "Uusimaa",
  9: "Uusimaa",
  10: "Uusimaa",
  11: "Kanta-Häme",
  12: "Kanta-Häme",
  13: "Kanta-Häme",
  14: "Pirkanmaa",
  15: "Päijät-Häme",
  16: "Päijät-Häme",
  17: "Päijät-Häme",
  18: "Päijät-Häme",
  19: "Päijät-Häme",
  20: "Varsinais-Suomi",
  21: "Varsinais-Suomi",
  22: "Ahvenanmaa",
  23: "Varsinais-Suomi",
  24: "Varsinais-Suomi",
  25: "Varsinais-Suomi",
  26: "Satakunta",
  27: "Varsinais-Suomi",
  28: "Satakunta",
  29: "Satakunta",
  30: "Kanta-Häme",
  31: "Varsinais-Suomi",
  32: "Varsinais-Suomi",
  33: "Pirkanmaa",
  34: "Pirkanmaa",
  35: "Pirkanmaa",
  36: "Pirkanmaa",
  37: "Pirkanmaa",
  38: "Satakunta",
  39: "Satakunta",
  40: "Keski-Suomi",
  41: "Keski-Suomi",
  42: "Pirkanmaa",
  43: "Keski-Suomi",
  44: "Keski-Suomi",
  45: "Kymenlaakso",
  46: "Kymenlaakso",
  47: "Uusimaa",
  48: "Kymenlaakso",
  49: "Kymenlaakso",
  50: "Etelä-Savo",
  51: "Etelä-Savo",
  52: "Kymenlaakso",
  53: "Etelä-Karjala",
  54: "Kymenlaakso",
  55: "Etelä-Karjala",
  56: "Etelä-Karjala",
  57: "Etelä-Savo",
  58: "Pohjois-Karjala",
  59: "Pohjois-Karjala",
  60: "Etelä-Pohjanmaa",
  61: "Pohjanmaa",
  62: "Pohjanmaa",
  63: "Etelä-Pohjanmaa",
  64: "Pohjanmaa",
  65: "Pohjanmaa",
  66: "Pohjanmaa",
  67: "Keski-Pohjanmaa",
  68: "Pohjois-Pohjanmaa",
  69: "Keski-Pohjanmaa",
  70: "Pohjois-Savo",
  71: "Pohjois-Savo",
  72: "Pohjois-Savo",
  73: "Pohjois-Savo",
  74: "Pohjois-Savo",
  75: "Pohjois-Savo",
  76: "Etelä-Savo",
  77: "Pohjois-Savo",
  78: "Pohjois-Savo",
  79: "Pohjois-Savo",
  80: "Pohjois-Karjala",
  81: "Pohjois-Karjala",
  82: "Pohjois-Karjala",
  83: "Pohjois-Karjala",
  84: "Pohjois-Pohjanmaa",
  85: "Pohjois-Pohjanmaa",
  86: "Pohjois-Pohjanmaa",
  87: "Kainuu",
  88: "Pohjois-Pohjanmaa",
  89: "Kainuu",
  90: "Pohjois-Pohjanmaa",
  91: "Pohjois-Pohjanmaa",
  92: "Pohjois-Pohjanmaa",
  93: "Pohjois-Pohjanmaa",
  94: "Lappi",
  95: "Pohjois-Pohjanmaa",
  96: "Lappi",
  97: "Lappi",
  98: "Lappi",
  99: "Lappi",
};

export const regions = [
  {
    region: "Ahvenanmaa",
    lat: 61.9241,
    lng: 25.7482,
    radiusKm: 18.0,
  },
  {
    region: "Etelä-Karjala",
    lat: 61.2033,
    lng: 28.6226,
    radiusKm: 31.5,
  },
  {
    region: "Etelä-Pohjanmaa",
    lat: 62.9433,
    lng: 23.5285,
    radiusKm: 40.0,
  },
  {
    region: "Etelä-Savo",
    lat: 61.6945,
    lng: 27.8005,
    radiusKm: 49.5,
  },
  {
    region: "Kainuu",
    lat: 64.3737,
    lng: 28.7437,
    radiusKm: 60.0,
  },
  {
    region: "Kanta-Häme",
    lat: 60.907,
    lng: 24.3005,
    radiusKm: 22.5,
  },
  {
    region: "Keski-Pohjanmaa",
    lat: 63.5622,
    lng: 24.0014,
    radiusKm: 36.0,
  },
  {
    region: "Keski-Suomi",
    lat: 62.5667,
    lng: 25.5549,
    radiusKm: 45.0,
  },
  {
    region: "Kymenlaakso",
    lat: 60.5977,
    lng: 27.2591,
    radiusKm: 35.0,
  },
  {
    region: "Lappi",
    lat: 67.9222,
    lng: 26.5046,
    radiusKm: 150.0,
  },
  {
    region: "Pirkanmaa",
    lat: 61.6987,
    lng: 23.7896,
    radiusKm: 45.0,
  },
  {
    region: "Pohjanmaa",
    lat: 63.2862,
    lng: 21.4766,
    radiusKm: 55.0,
  },
  {
    region: "Pohjois-Karjala",
    lat: 62.8062,
    lng: 30.1554,
    radiusKm: 65.0,
  },
  {
    region: "Pohjois-Pohjanmaa",
    lat: 64.7151,
    lng: 26.0188,
    radiusKm: 93.5,
  },
  {
    region: "Pohjois-Savo",
    lat: 62.9424,
    lng: 27.7044,
    radiusKm: 60.0,
  },
  {
    region: "Päijät-Häme",
    lat: 61.323,
    lng: 25.7322,
    radiusKm: 30.0,
  },
  {
    region: "Satakunta",
    lat: 61.5933,
    lng: 22.1483,
    radiusKm: 40.0,
  },
  {
    region: "Uusimaa",
    lat: 60.2187,
    lng: 25.2716,
    radiusKm: 42.4,
  },
  {
    region: "Varsinais-Suomi",
    lat: 60.3628,
    lng: 22.4439,
    radiusKm: 40.0,
  },
];

export const regionMainStations = {
  Ahvenanmaa: {
    postalCode: "22100",
    name: "Mariehamns busstation",
    supported: false,
    lat: 60.1043,
    lng: 19.9356,
  },
  "Etelä-Karjala": {
    postalCode: "53100",
    name: "Lappeenrannan linja-autoasema",
    supported: false,
    lat: 61.0557,
    lng: 28.196,
  },
  "Etelä-Pohjanmaa": {
    postalCode: "60100",
    name: "Seinäjoen linja-autoasema",
    supported: false,
    lat: 62.7815,
    lng: 22.8623,
  },
  "Etelä-Savo": {
    postalCode: "50100",
    name: "Mikkelin linja-autoasema",
    supported: true,
    lat: 61.6895,
    lng: 27.2742,
  },
  Kainuu: {
    postalCode: "87100",
    name: "Kajaanin linja-autoasema",
    supported: false,
    lat: 64.2221,
    lng: 27.73,
  },
  "Kanta-Häme": {
    postalCode: "13100",
    name: "Hämeenlinnan linja-autoasema",
    supported: false,
    lat: 60.9949,
    lng: 24.4669,
  },
  "Keski-Pohjanmaa": {
    postalCode: "67100",
    name: "Kokkolan linja-autoasema",
    supported: false,
    lat: 63.8357,
    lng: 23.1279,
  },
  "Keski-Suomi": {
    postalCode: "40100",
    name: "Jyväskylän matkakeskus",
    supported: false,
    lat: 62.2422,
    lng: 25.7554,
  },
  Kymenlaakso: {
    postalCode: "48100",
    name: "Kotkan linja-autoasema",
    supported: false,
    lat: 60.4615,
    lng: 26.939,
  },
  Lappi: {
    postalCode: "96100",
    name: "Rovaniemen matkakeskus",
    supported: false,
    lat: 66.5711,
    lng: 25.6084,
  },
  Pirkanmaa: {
    postalCode: "33100",
    name: "Hatanpään valtatie 5-7, Tampere",
    supported: true,
    lat: 61.4936,
    lng: 23.769,
  },
  Pohjanmaa: {
    postalCode: "65100",
    name: "Vaasan linja-autoasema",
    supported: false,
    lat: 63.0954,
    lng: 21.6236,
  },
  "Pohjois-Karjala": {
    postalCode: "80100",
    name: "Joensuun linja-autoasema",
    supported: false,
    lat: 62.6014,
    lng: 29.7776,
  },
  "Pohjois-Pohjanmaa": {
    postalCode: "90100",
    name: "Oulun linja-autoasema",
    supported: false,
    lat: 65.0088,
    lng: 25.4842,
  },
  "Pohjois-Savo": {
    postalCode: "70100",
    name: "Kuopion linja-autoasema",
    supported: true,
    lat: 62.8977,
    lng: 27.6796,
  },
  "Päijät-Häme": {
    postalCode: "15100",
    name: "Lahden matkakeskus",
    supported: false,
    lat: 60.9769,
    lng: 25.6576,
  },
  Satakunta: {
    postalCode: "28130",
    name: "Porin matkakeskus",
    supported: false,
    lat: 61.4774,
    lng: 21.7877,
  },
  Uusimaa: {
    postalCode: "00100",
    name: "Narinkka 1, Helsinki",
    supported: true,
    lat: 60.1698,
    lng: 24.9345,
  },
  "Varsinais-Suomi": {
    postalCode: "20100",
    name: "Aninkaistenkatu, Turku",
    supported: true,
    lat: 60.4554,
    lng: 22.2702,
  },
};
